import React, { useEffect, useState, useLayoutEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useTheme } from "@material-ui/core"
import { operationsHelper } from "../../helpers/operations"
//import {findDOMNode} from 'react-dom';
import {
	changeTermTarget,
	changeIgnoreRelated,
	changeIncludeSpecific,
	changeIgnoreSpecific,
	setUnsaveFlag,
	setHighlightConcepts,
	setForceCloudRefresh,
	setSearchTerms,
} from "../../actions/buildconceptActions"
import SimplePopover from "./btnInfo"
import { Fragment } from "react"

import cloud from "d3-cloud"
import { scaleOrdinal } from "d3-scale"
import { schemeCategory10 } from "d3-scale-chromatic"
import { pointer, select } from "d3-selection"

import InfoDialog from "../common/InfoDialog"
import color_legend from "../../images/color_legend.png"
import Rainbow from "../Rainbow"

const TagsCloud = ({ currentSearchTermsSelected, setRefreshCloudList, setShowColorLegend, showColorLegend }) => {
	/* ******************* REDUX STORE ******************* */
	const theme = useTheme()
	//Redux actions
	const topicResult = useSelector((state) => state.buildconcept.topicBuilderResults)
	const targetTerms = useSelector((state) => state.buildconcept.targetTerms)
	const ignoreTerms = useSelector((state) => state.buildconcept.ignoreTerms)
	const includeSpecificTerms = useSelector((state) => state.buildconcept.includeSpecificTerms)
	const ignoreSpecificTerms = useSelector((state) => state.buildconcept.ignoreSpecificTerms)
	const currentNeg = useSelector((state) => state.buildconcept.currentFilter.neg_phrase_count)
	const forceReload = useSelector((state) => state.buildconcept.force_tag_refresh)
	const searchTerms = useSelector((state) => state.buildconcept.searchTerms)
	const topicBuilderResults = useSelector((state) => state.buildconcept.topicBuilderResults)

	const dispatch = useDispatch()
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	const [wordData, setWordData] = useState([])
	const [clickedWord, setClickedWord] = useState(null)
	const [inicialized, setInicialized] = useState(false)
	//Info button
	const [btninfo, setBtnInfo] = useState("tagsCloud")
	const [sizeCloud, setSizeCloud] = useState(800)
	const [sortTopicResult, setSortTopicResult] = useState([])

	const [heatMapResult, setHeatMapResult] = useState({})

	const [showHeatmapColors, setShowHeatmapColors] = useState(showColorLegend)
	/* ******************* END REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */
	//Update number of negatives shown in list
	useEffect(() => {
		if (sortTopicResult.length === 0) {
			return
		}
		var negativeItems = document.getElementsByClassName("bottom_color_relatedness_negative")
		for (var i = 0; i < negativeItems.length; i++) {
			if (i + 1 < currentNeg) {
				negativeItems[i].classList.remove("hideNegative")
			} else {
				negativeItems[i].classList.add("hideNegative")
			}
		}

		let maxValuePositive = operationsHelper.maxRelatednessPositive(topicResult)
		let minValuePositive = operationsHelper.minRelatednessPositive(topicResult)
		let maxValueNegative = operationsHelper.maxRelatednessNegative(topicResult)
		//let minValueNegative = operationsHelper.minRelatednessNegative(topicResult);
		let minValueNegative = operationsHelper.minRelatedness(topicResult)

		setInicialized(false)
		buildTagWordsData()
		select(wordCloud).selectAll("*").remove()
		loadWordCloud_d3()
		layout.start()

		dispatch(setForceCloudRefresh(false))

		//Modify the list of terms searching for
		let positiveSearch = sortTopicResult.filter((i) => i[2] >= 0).map((i) => `"${i[1]}"`)
		let negativeSearch = sortTopicResult
			.filter((i) => i[2] < 0)
			.slice(0, currentNeg)
			.map((i) => `"${i[1]}"`)
		dispatch(setHighlightConcepts({ positive: positiveSearch, negative: negativeSearch }))
	}, [sortTopicResult])

	//Sort the topicResult based of target, ignore expecific and related
	useEffect(() => {
		let auxTarget = topicResult.filter((i) => targetTerms.includes(i[1]))
		let minColorAux = Math.max.apply(
			null,
			auxTarget.map((i) => i[2])
		)
		auxTarget = auxTarget.concat(topicResult.filter((i) => includeSpecificTerms.includes(i[1])))
		let auxExclude = topicResult.filter((i) => ignoreTerms.includes(i[1]))
		auxExclude = auxExclude.concat(topicResult.filter((i) => ignoreSpecificTerms.includes(i[1])))
		let maxColorAux = Math.min.apply(
			null,
			auxExclude.map((i) => i[2])
		)

		let listWithExcludes = topicResult.filter((i) => !auxTarget.includes(i))
		listWithExcludes = listWithExcludes.filter((i) => !auxExclude.includes(i))
		//Now split listWithExcludes in positive an negatives
		let positiveListWithExcludes = listWithExcludes.filter((i) => i[2] >= 0)
		let negativeListWithExcludes = listWithExcludes.filter((i) => i[2] < 0)
		//Now, add to the auxTarget tems the max relattioness for the coloring
		//get the min color:
		for (var i = 0; i < auxTarget.length; i++) {
			if (auxTarget[i][2] < minColorAux) {
				auxTarget[i][2] = minColorAux
			}
		}
		for (var i = 0; i < auxExclude.length; i++) {
			if (auxExclude[i][2] > maxColorAux) {
				auxExclude[i][2] = maxColorAux
			}
		}
		setSortTopicResult(auxTarget.concat(positiveListWithExcludes).concat(auxExclude).concat(negativeListWithExcludes))
	}, [topicResult])

	useEffect(() => {
		if (sortTopicResult.length === 0) {
			return
		}
		buildTagWordsData()
		dispatch(setForceCloudRefresh(false))
	}, [sortTopicResult])

	useEffect(() => {
		setShowColorLegend(showHeatmapColors)
		if (sortTopicResult.length === 0) {
			return
		}
		buildTagWordsData(true)
		dispatch(setForceCloudRefresh(false))
	}, [showHeatmapColors])

	const reloadCloud = () => {
		setTimeout(function () {
			if (sortTopicResult.length === 0) {
				return
			}
			buildTagWordsData()
			select(wordCloud).selectAll("*").remove()
			loadWordCloud_d3()
			layout.start()
			dispatch(setForceCloudRefresh(false))
		}, 200)
	}

	useEffect(() => {
		if (forceReload) {
			reloadCloud()
		}
	}, [forceReload])

	useEffect(() => {
		if (inicialized === false && wordData.length > 0) {
			loadWordCloud_d3()
			layout.start()
			setInicialized(true)
		}
	}, [wordData])

	useLayoutEffect(() => {
		function updateSize() {
			setSizeCloud(
				document.getElementById("cloud-container-parent").offsetWidth -
					document.getElementById("cloud-result-list").offsetWidth -
					50
			)
		}
		window.addEventListener("resize", updateSize)
		updateSize()

		return () => window.removeEventListener("resize", updateSize)
	}, [])

	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */

	const handelSearchTermChange = (action, currTerm) => {
		let updatedState = []
		if (action === "add") {
			updatedState = !_.includes(searchTerms, currTerm) ? [...searchTerms, currTerm] : [...searchTerms]
		} else if (action === "remove") {
			updatedState = searchTerms?.filter((term) => term !== currTerm)
		}

		setClickedWord(null)

		dispatch(setSearchTerms(updatedState))
		setRefreshCloudList(Math.random())
	}

	const buildTagWordsData = (forceReload = false) => {
		//Create heatmap colors fist
		let auxHeat = {}
		if (showHeatmapColors === true) {
			let selectedTerms =
				currentSearchTermsSelected.target_terms === null || currentSearchTermsSelected.target_terms === undefined
					? []
					: currentSearchTermsSelected.target_terms
			let selectedSoft =
				currentSearchTermsSelected.soft_target === null || currentSearchTermsSelected.soft_target === undefined
					? []
					: currentSearchTermsSelected.soft_target
			let selectExclude =
				currentSearchTermsSelected.ignore_terms === null || currentSearchTermsSelected.ignore_terms === undefined
					? []
					: currentSearchTermsSelected.ignore_terms
			let selectSoftIgnore =
				currentSearchTermsSelected.soft_ignore === null || currentSearchTermsSelected.soft_ignore === undefined
					? []
					: currentSearchTermsSelected.soft_ignore

			//los target tems son verdes
			selectedTerms.map((term) => {
				auxHeat[term] = "#222222"
			})
			selectedSoft.map((term) => {
				auxHeat[term] = "#222222"
			})
			selectExclude.map((term) => {
				auxHeat[term] = "#E1E1E1"
			})
			selectSoftIgnore.map((term) => {
				auxHeat[term] = "#E1E1E1"
			})
			let negatives = JSON.parse(JSON.stringify(sortTopicResult))
			negatives
				.filter((item) => item[2] < 0)
				.map((term) => {
					auxHeat[term[1]] = "#E1E1E1"
				})
			let clone = JSON.parse(JSON.stringify(sortTopicResult))
			clone = clone.filter((item) => {
				return Object.keys(auxHeat).indexOf(item[1]) === -1
			})
			//del resto calculamos el percentil, que es el número de valores por debajo de ese número / número de valores * 100
			clone.map((item) => {
				//    let numero_menores= clone.filter(item2 => (item2[2]<= item[2])).length;
				//    let percentil= (numero_menores/clone.length) * 100;
				//    if (percentil < 19){
				//         auxHeat[item[1]]='#B4C6E7';
				//    }else if (percentil<39){
				//         auxHeat[item[1]]='#FCE4D6';
				//    }else if (percentil<59){
				//         auxHeat[item[1]]='#FFCC99';
				//     }else if (percentil<79){
				//         auxHeat[item[1]]='#C6EFCE';
				//     }else{
				//         auxHeat[item[1]]='#FFC7CE';
				//     }

				let numero_menores = clone.filter((item2) => item2[2] <= item[2]).length
				let percentil = numero_menores / clone.length
				// Los percentiles van de 0 a 1.
				// Los grados para el rainbow van de 0 a 206
				auxHeat[item[1]] = "hsl(" + (206 - percentil * 206) + ", 100%, 50%)"
			})
		} else {
			sortTopicResult.map((item) => {
				auxHeat[item[1]] = "#222222"
			})
		}
		setHeatMapResult(auxHeat)

		//create words

		relatedness = sortTopicResult.map((x) => parseFloat(x[2]))
		relatedness = operationsHelper.normalize_array(relatedness)
		hits = sortTopicResult.map((x) => parseFloat(x[0]))
		hits = operationsHelper.normalize_array(hits)
		let auxWordData = []
		let negativeTemrsCount = 0
		for (var i = 0; i < sortTopicResult.length; i++) {
			if (sortTopicResult[i][2] > 0) {
				//let newTerm={"text": sortTopicResult[i][1], "value": parseInt(relatedness[i]), "color": `hsl(${setHeatMap(sortTopicResult[i][2]) },40%, 50%)`,"hits": parseInt(hits[i])};
				//let newTerm={"text": sortTopicResult[i][1], "value": parseInt(relatedness[i]), "color": setHeatMapScale4Colors(sortTopicResult[i][1],sortTopicResult[i][2]),"hits": parseInt(hits[i])};
				let newTerm = {
					text: sortTopicResult[i][1],
					value: parseInt(relatedness[i]),
					color: searchTerms?.includes(sortTopicResult[i][1])
						? theme.palette.grey["D1600"]
						: auxHeat.hasOwnProperty(sortTopicResult[i][1])
						? auxHeat[sortTopicResult[i][1]]
						: "#000",
					hits: parseInt(hits[i]),
					textDecoration: searchTerms?.includes(sortTopicResult[i][1]) ? "line-through" : "none",
				}

				auxWordData.push(newTerm)
			}
			// }else{
			//     if (negativeTemrsCount<currentNeg){
			//         //let newTerm={"text": sortTopicResult[i][1], "value": parseInt(relatedness[i]), "color": setHeatMapScale4Colors(sortTopicResult[i][1],sortTopicResult[i][2]),"hits": parseInt(hits[i])};
			//         let newTerm={"text": sortTopicResult[i][1], "value": parseInt(relatedness[i]), "color": (auxHeat.hasOwnProperty(sortTopicResult[i][1]) ? auxHeat[sortTopicResult[i][1]] :'#000' ),"hits": parseInt(hits[i])};
			//         auxWordData.push(newTerm);
			//         negativeTemrsCount++;
			//     }
			// }
		}
		setWordData(auxWordData)
		dispatch(setForceCloudRefresh(false))
		if (forceReload) {
			setTimeout(function () {
				dispatch(setForceCloudRefresh(true))
			}, 200)
		}
	}

	/* Select current term as Target Term */
	const changeTargetTerm = (term, checked) => {
		if (checked === true) {
			dispatch(changeTermTarget(term, true))
			dispatch(changeIgnoreRelated(term, false))
			dispatch(changeIncludeSpecific(term, false))
			dispatch(changeIgnoreSpecific(term, false))
		} else {
			dispatch(changeTermTarget(term, false))
		}
		dispatch(setUnsaveFlag(true))
		setClickedWord(null)
		setRefreshCloudList(Math.random())
	}

	/* Select current term as Ignore Related */
	const changeIgnoreRelatedState = (term, checked) => {
		if (checked === true) {
			dispatch(changeTermTarget(term, false))
			dispatch(changeIgnoreRelated(term, true))
			dispatch(changeIncludeSpecific(term, false))
			dispatch(changeIgnoreSpecific(term, false))
		} else {
			dispatch(changeIgnoreRelated(term, false))
		}
		dispatch(setUnsaveFlag(true))
		setClickedWord(null)
		setRefreshCloudList(Math.random())
	}

	/* Select current term as Inclide Specific */
	const changeIncludeSpecificState = (term, checked) => {
		if (checked === true) {
			dispatch(changeTermTarget(term, false))
			dispatch(changeIgnoreRelated(term, false))
			dispatch(changeIncludeSpecific(term, true))
			dispatch(changeIgnoreSpecific(term, false))
		} else {
			dispatch(changeIncludeSpecific(term, false))
		}
		dispatch(setUnsaveFlag(true))
		setClickedWord(null)
		setRefreshCloudList(Math.random())
	}

	/* Select current term as Ignore Specific */
	const changeIgnoreSpecificState = (term, checked) => {
		if (checked === true) {
			dispatch(changeTermTarget(term, false))
			dispatch(changeIgnoreRelated(term, false))
			dispatch(changeIncludeSpecific(term, false))
			dispatch(changeIgnoreSpecific(term, true))
		} else {
			dispatch(changeIgnoreSpecific(term, false))
		}
		dispatch(setUnsaveFlag(true))
		setClickedWord(null)
		setRefreshCloudList(Math.random())
	}

	const setListTermsColor = (relatedness) => {
		if (relatedness < 0) {
			return "bottom_color_relatedness_negative"
		} else {
			switch (parseInt(relatedness)) {
				case 0:
					return "bottom_color_relatedness_0"
					break
				case 1:
					return "bottom_color_relatedness_1"
					break
				case 2:
					return "bottom_color_relatedness_2"
					break
				case 3:
					return "bottom_color_relatedness_3"
					break
				case 4:
					return "bottom_color_relatedness_4"
					break
				default:
					return "bottom_color_relatedness_5"
			}
		}
	}

	const newSetListTermsColor = (relatedness) => {
		if (relatedness < 0) {
			return "bi bi-circle-fill cloudTermColor_negative mr-2"
		} else {
			switch (parseInt(relatedness)) {
				case 0:
					return "bi bi-circle-fill cloudTermColor_0 mr-2"
					break
				case 1:
					return "bi bi-circle-fill cloudTermColor_1 mr-2"
					break
				case 2:
					return "bi bi-circle-fill cloudTermColor_2 mr-2"
					break
				case 3:
					return "bi bi-circle-fill cloudTermColor_3 mr-2"
					break
				case 4:
					return "bi bi-circle-fill cloudTermColor_4 mr-2"
					break
				default:
					return "bi bi-circle-fill cloudTermColor_5 mr-2"
			}
		}
	}

	const setHeatMapScale4Colors = (term, value) => {
		//coment until there is a solution
		return "#222"
		let scales = ["#ee7b32", "#b20a1c", "#bebebe", "#696969"]

		let selectedTerms =
			currentSearchTermsSelected.target_terms === null || currentSearchTermsSelected.target_terms === undefined
				? []
				: currentSearchTermsSelected.target_terms
		let selectedSoft =
			currentSearchTermsSelected.soft_target === null || currentSearchTermsSelected.soft_target === undefined
				? []
				: currentSearchTermsSelected.soft_target
		let selectExclude =
			currentSearchTermsSelected.ignore_terms === null || currentSearchTermsSelected.ignore_terms === undefined
				? []
				: currentSearchTermsSelected.ignore_terms
		let selectSoftIgnore =
			currentSearchTermsSelected.soft_ignore === null || currentSearchTermsSelected.soft_ignore === undefined
				? []
				: currentSearchTermsSelected.soft_ignore

		if (value >= 0) {
			if (selectedTerms.indexOf(term) !== -1 || selectedSoft.indexOf(term) !== -1) {
				return scales[0]
			} else {
				return scales[1]
			}
		} else {
			if (selectExclude.indexOf(term) !== -1 || selectSoftIgnore.indexOf(term) !== -1) {
				return scales[2]
			} else {
				return scales[3]
			}
		}
	}

	const setHeatMapScale = (value) => {
		let scales = ["#050aac", "#4d65e2", "#bebebe", "#dd7b50", "#b20a1c"]
		//Split values into 5 scales lineally
		//find index in relationess
		if (sortTopicResult.length > 0) {
			let minV = Math.min.apply(
				Math,
				sortTopicResult.map((element) => element[2])
			)
			let maxV = Math.max.apply(
				Math,
				sortTopicResult.map((element) => element[2])
			)
			let normalizado = (value - minV) / (maxV - minV)
			//Set the result. Not the best code, but works
			if (normalizado < 0.2) {
				return scales[0]
			} else if (normalizado < 0.4) {
				return scales[1]
			} else if (normalizado < 0.6) {
				return scales[2]
			} else if (normalizado < 0.8) {
				return scales[3]
			} else {
				return scales[4]
			}
		} else {
			return "#fff"
		}
	}

	const setHeatMap = (value) => {
		/*
       Linear slope  (Ymax - Ymin)/(Xmax - Xmin)  -----> Ymax= 206, Ymin= 0 
       Positive goes from 0 to 180
       */
		if (value > 0) {
			let slope = 180 / (maxValuePositive - minValuePositive)
			let b = -slope * minValuePositive

			let hlsDegree = 180 - (slope * value + b)
			return hlsDegree
		} else {
			/* Negatives goes from 240 to 320 */
			let slope = (240 - 320) / (maxValueNegative - minValueNegative)
			let b = -slope * minValueNegative

			let hlsDegree = 240 + (slope * value + b)
			return hlsDegree
		}
	}

	const fontSizeMapper = (word) => {
		switch (word.hits) {
			case 2:
				return 25
			case 3:
				return 30
			case 4:
				return 35
			case 5:
				return 40
			case 6:
				return 45
			default:
				return 45
		}
	}
	const fontPadding = (word) => {
		return word.value * 3
	}

	const lengthCloud = () => {
		if (wordData.length < 25) {
			return 200
		}
		if (wordData.length < 50) {
			return 300
		}
		if (wordData.length < 100) {
			return 400
		}
		if (wordData.length < 150) {
			return 500
		}

		return 800
	}

	const loadWordCloud_d3 = () => {
		// render based on new data
		if (wordData.length === 0) {
			buildTagWordsData()
			//loadWordCloud_d3();
		} else {
			select(wordCloud).selectAll("*").remove()
			layout
				.size([sizeCloud, lengthCloud()])
				.font(
					"-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
				)
				.words(wordData)
				//.padding(fontPadding)
				.padding(5)
				.rotate(0)
				.fontSize(fontSizeMapper)
				//.fontSize(10)
				.spiral("rectangular")
				.on("end", (words) => {
					let size_0 = layout.size()[0] / 2
					let size_1 = layout.size()[1] / 2
					if (size_1 === 1000) {
						size_1 = 650
					}

					const texts = select(wordCloud)
						.append("svg")
						.attr("width", layout.size()[0])
						.attr("height", layout.size()[1])
						.append("g")
						.attr("transform", `translate(${size_0},${size_1})`)
						.selectAll("text")
						.data(words)
						.enter()
						.append("text")
						.style("font-size", (d) => `${d.size}px`)
						.style(
							"font-family",
							"-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
						)
						//.style('fill', (d, i) => fill(i))
						.style("fill", (d) => d.color)
						.style("text-decoration", (d) => d.textDecoration)
						.style("cursor", "pointer")
						//.style("text-shadow", "1px 1px 3px #000000")
						.attr("text-anchor", "middle")
						.attr("transform", (d) => `translate(${[d.x, d.y]})rotate(${d.rotate})`)
						.text((d) => d.text)

					texts.on("click", (word) => {
						setClickedWord(word.text)
					})
				})
		}
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	const wordCloud = document.getElementById("cloud-wrapper")
	let relatedness = sortTopicResult.map((x) => parseFloat(x[2]))
	relatedness = operationsHelper.normalize_array(relatedness)

	let hits = sortTopicResult.map((x) => parseInt(x[0]))
	hits = operationsHelper.normalize_array(hits)
	// HeatMap Colours Mapping
	let maxValuePositive = operationsHelper.maxRelatednessPositive(sortTopicResult)
	let minValuePositive = operationsHelper.minRelatednessPositive(sortTopicResult)
	let maxValueNegative = operationsHelper.maxRelatednessNegative(sortTopicResult)
	//let minValueNegative = operationsHelper.minRelatednessNegative(topicResult);
	let minValueNegative = operationsHelper.minRelatedness(sortTopicResult)
	const layout = cloud()
	/* ******************* END VARIABLES ******************* */

	return (
		<Fragment>
			<div className="col-12 col-md-12 col-lg-12 cloud-container" id="cloud-container-parent">
				{!!topicResult.length ? <div id="cloud-wrapper" className="inline-block"></div> : null}
				<div id="col2_block_cloud">
					<div className="col-12">
						<div id="cloud-result-list" className="col-12 divBlock">
							<ul>
								<li>
									<div className="col-12 divBlock">
										<div className="col-9 divBlock">
											<h5 className="pl-2 titleCardMenuCloud" style={{ paddingTop: "7px" }}>
												Target terms
											</h5>
										</div>
										<div className="col-3 divBlock info_cloud_right">
											<InfoDialog btninfo="target" />
										</div>
									</div>
									<div className="col-12 divBlock">
										<ul className="ulCardMenuCloud">
											{targetTerms.map((item, i) => (
												<li
													data-cy={item}
													key={i}
													onClick={(e) => {
														changeTargetTerm(item, false)
													}}
												>
													{item}
												</li>
											))}
										</ul>
									</div>
								</li>
								{/* <li>
									<div className="col-12 divBlock">
										<div className="col-9 divBlock">
											<h5 className="pl-2 titleCardMenuCloud" style={{ paddingTop: "7px" }}>
												Remove Related Terms
											</h5>
										</div>
										<div className="col-3 divBlock info_cloud_right">
											<InfoDialog btninfo="ignoreRelated" />
										</div>
									</div>
									<div className="col-12 divBlock">
										<ul className="ulCardMenuCloud">
											{ignoreTerms.map((item, i) => (
												<li
													data-cy={item}
													key={i}
													onClick={(e) => {
														changeIgnoreRelatedState(item, false)
													}}
												>
													{item}
												</li>
											))}
										</ul>
									</div>
								</li> */}
								{/* <li>
									<div className="col-12 divBlock">
										<div className="col-9 divBlock">
											<h5 className="pl-2 titleCardMenuCloud" style={{ paddingTop: "7px" }}>
												Include specific
											</h5>
										</div>
										<div className="col-3 divBlock info_cloud_right">
											<InfoDialog btninfo="includeSpecific" />
										</div>
									</div>
									<div className="col-12 divBlock">
										<ul className="ulCardMenuCloud">
											{includeSpecificTerms.map((item, i) => (
												<li
													data-cy={item}
													key={i}
													onClick={(e) => {
														changeIncludeSpecificState(item, false)
													}}
												>
													{item}
												</li>
											))}
										</ul>
									</div>
								</li> */}
								<li>
									<div className="col-12 divBlock">
										<div className="col-9 divBlock">
											<h5 className="pl-2 titleCardMenuCloud" style={{ paddingTop: "7px" }}>
												Remove from search
											</h5>
										</div>
										<div className="col-3 divBlock info_cloud_right">
											<InfoDialog btninfo="ignoreSpecific" />
										</div>
									</div>
									<div className="col-12 divBlock">
										<ul className="ulCardMenuCloud">
											{sortTopicResult
												?.filter((term) => searchTerms?.includes(term?.[1]))
												?.map((item, i) => (
													<li
														data-cy={item?.[1]}
														key={i}
														onClick={(e) => {
															handelSearchTermChange("remove", item?.[1])
														}}
													>
														{item?.[1]}
													</li>
												))}
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>

					{/* <div className="col-12 divBlocl mt-4" style={{ float: "left" }}>
						<div className="form-switch" style={{ paddingLeft: "0px" }}>
							<input
								className=" form-check-input sourceFilterCheck"
								//id={key}
								type="checkbox"
								defaultChecked={showHeatmapColors}
								onChange={(e) => {
									setShowHeatmapColors(!showHeatmapColors)
								}}
							/>{" "}
							Show Heatmap
						</div>
					</div>*/}
					<Rainbow showHeatmapColors={showHeatmapColors} />
				</div>
			</div>

			<div className="popup_cloud" id={`popup_0`} style={{ display: clickedWord != null ? "block" : "none" }}>
				<ul>
					<li>
						<p className="h2 text-center py-2 pb-3">{clickedWord}</p>
					</li>
					<li
						onClick={(e) => {
							e.preventDefault()
							changeTargetTerm(clickedWord, true)
						}}
					>
						<div className="col-12 ">
							<h4 data-cy={"target_terms_" + clickedWord} className="popupOptionTagsCloud">
								<i className="bi bi-eye-fill cloudIcon"></i> Add this to target terms
							</h4>
						</div>
						<div className="col-12">
							<p className="p-cloud">When you search to include related terms to the ones selected</p>
						</div>
					</li>
					{/* <li
						onClick={(e) => {
							e.preventDefault()
							changeIgnoreRelatedState(clickedWord, true)
						}}
					>
						<div className="col-12 ">
							<h4 data-cy={"ignore_related_" + clickedWord} className="popupOptionTagsCloud">
								<i className="bi bi-eye-slash-fill cloudIcon"></i> Remove this from related terms
							</h4>
						</div>
						<div className="col-12">
							<p className="p-cloud">Narrows your search by removing the selected terms, and related ones.</p>
						</div>
					</li> */}
					{/* <li
						onClick={(e) => {
							e.preventDefault()
							changeIncludeSpecificState(clickedWord, true)
						}}
					>
						<div className="col-12 ">
							<h4 data-cy={"include_specific_" + clickedWord} className="popupOptionTagsCloud">
								<i className="bi bi-plus cloudIcon"></i> Add specific terms
							</h4>
						</div>
						<div className="col-12">
							<p className="p-cloud">
								Widens your search by including only the selected terms to the concept. Specifically adding a term does not
								cover related terms.
							</p>
						</div>
					</li> */}
					{/* <li
						onClick={(e) => {
							e.preventDefault()
							changeIgnoreSpecificState(clickedWord, true)
						}}
					>
						<div className="col-12 ">
							<h4 data-cy={"ignore_specific_" + clickedWord} className="popupOptionTagsCloud">
								<i className="bi bi-x cloudIcon"></i> Remove from search
							</h4>
						</div>
						<div className="col-12">
							<p className="p-cloud">Narrow your search by removing the term from the concept</p>
						</div>
					</li>
					<li className="py-4 text-center">
						<button
							className="btn btn-primary"
							onClick={(e) => {
								e.preventDefault()
								setClickedWord(null)
							}}
						>
							Close
						</button>{" "}
					</li> */}

					<li
						onClick={(e) => {
							e.preventDefault()
							//changeIgnoreSpecificState(clickedWord, true)
							handelSearchTermChange("add", clickedWord)
						}}
					>
						<div className="col-12 ">
							<h4 data-cy={"ignore_specific_" + clickedWord} className="popupOptionTagsCloud">
								<i className="bi bi-x cloudIcon"></i> Remove from search
							</h4>
						</div>
						<div className="col-12">
							<p className="p-cloud">Narrow your search by removing the term from the concept</p>
						</div>
					</li>
					<li className="py-4 text-center">
						<button
							className="btn btn-primary"
							onClick={(e) => {
								e.preventDefault()
								setClickedWord(null)
							}}
						>
							Close
						</button>{" "}
					</li>
				</ul>
			</div>
		</Fragment>
	)
}

export default TagsCloud
